<template>
  <div>
    <!-- <header class="header" v-if="isStudent">
      <button
        class="btn btn--border-grey st-qr-fixed"
        @click="showQRPopup = true"
        tabindex="0"
      >
        <icon name="header__sb-btn-icon-2" width="32" height="32" />
        <span>תעודה שלי</span>
      </button>
      <ul
        v-click-outside="() => (showCampusSelect = false)"
        class="school-switcher__list"
      >
        <li
          v-for="campus of campuses"
          :key="campus.id"
          class="school-switcher__list-item"
          :class="{
            active: selectedCampus ? selectedCampus.id === campus.id : false
          }"
          @click="selectCampus(campus)"
        >
          <div class="school-switcher__list-item-logo">
            <img v-if="campus.logo" :src="campus.logo" alt="" />
            <img v-else src="/images/sm-logo.svg" alt="" />
          </div>
          <div class="school-switcher__list-item-info">
            <div class="school-switcher__list-item-title">
              {{ campus.text }}
            </div>
            <div class="school-switcher__list-item-text">פנימייה</div>
          </div>
        </li>
      </ul>
    </header> -->
    <header
      class="header"
      :class="{ moved: showMenu }"
      @click.self="closeUserAvatarHeader"
    >
      <div
        class="header__menu-btn"
        :class="{ active: showSidebar }"
        @click="hideSidebar()"
      >
        <icon name="menu-new-icon" class="header__sb-btn-icon-1" />
        <icon name="menu-new-icon" class="header__sb-btn-icon-2" />
      </div>
      <div :class="'header__sb-btn d-none'" @click="hideSidebar">
        <icon name="menu-new-icon" class="header__sb-btn-icon-1" />
        <icon name="menu-new-icon" class="header__sb-btn-icon-2" />
      </div>
      <div class="header__mob-group d-lg-none mr-md-2">
        <NotificationBell tag="div" :mobile="true" class="d-md-none" />
      </div>
      <ul class="header__controls d-none d-md-flex">
        <!-- <li
          class="
            header__controls-item
            header-tools__settings-item
            header__controls--disabled
          "
        >
          <a
            href="https://www.smart-campus.co.il/"
            target="_blank"
            class="header__controls-link"
            tabindex="0"
          >
            <div class="header__controls-counter header__controls-counter--red">
              8
            </div>
            <icon name="header__controls-link-1" />
          </a>
          <div class="tooltip left">עדכונים (בקרוב)</div>
        </li> -->
        <!-- <li class="header__controls-item">
          <router-link
            to="/calendar"
            class="header__controls-link"
            active-class="active"
            tabindex="0"
          >
            <div class="header__controls-counter" />
            <icon name="header__controls-link-2" />
          </router-link>
          <div class="tooltip bot">יומן (בקרוב)</div>
        </li> -->
        <li
          v-if="$perm('audit.view', selectedCampus && selectedCampus.id)"
          class="header__controls-item"
        >
          <router-link
            to="/audittrail"
            class="header__controls-link"
            active-class="active"
            tabindex="0"
          >
            <div class="header__controls-counter"></div>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 11.8461V8M9 11.8461C9.44501 11.0556 10.7114 9.64892 11.5096 9.24519C12.131 8.93088 12.8123 8.7692 13.5 8.76922C15.9853 8.76922 18 10.8357 18 13.3847C18 15.9337 15.9853 18 13.5 18C11.869 18 10.4406 17.11 9.65141 15.7778M9 11.8461H10.875M13.5 11.8889V13.5445L14.625 14.6667M2 8H5.5M2 8V14.5C2 15.3284 2.67157 16 3.5 16H6.5M2 8V4.5C2 3.67157 2.67157 3 3.5 3H16.5C17.3284 3 18 3.67157 18 4.5V7M15.5 5.5H15M12.5 5.5H12"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
          <div class="tooltip bot audit-tooltip">מעקב אירועים</div>
        </li>
        <li class="header__controls-item">
          <router-link
            to="/calendar"
            class="header__controls-link"
            active-class="active"
            tabindex="0"
          >
            <div class="header__controls-counter" />
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 2.5V5M7.5 2.5V5M3.33333 7.5H16.6667M4.16667 4.16667H15.8333C16.7538 4.16667 17.5 4.82995 17.5 5.64815V16.0185C17.5 16.8367 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.8367 2.5 16.0185V5.64815C2.5 4.82995 3.24619 4.16667 4.16667 4.16667Z"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
          <div class="tooltip bot">יומן אירועים</div>
        </li>
        <NotificationBell />

        <!-- <li class="header__controls-item header__controls--disabled">
          <a href="" class="header__controls-link" tabindex="0">
            <div class="header__controls-counter" />
            <icon name="header__controls-link-3" />
          </a>
          <div class="tooltip bot">משימות (בקרוב)</div>
        </li> -->
        <!-- <li
          class="header__controls-item"
          v-if="
            $perm(
              'knowledge_center.can_edit_the_knowledge_center',
              selectedCampus.id
            ) ||
            $perm(
              'knowledge_center.can_view_the_knowledge_center',
              selectedCampus.id
            )
          "
        >
          <router-link
            to="/knowledge-center-categories"
            class="header__controls-link knowled"
            active-class="active"
            tabindex="0"
          >
            <div class="header__controls-counter" />
            <icon name="header__controls-link-8" />
          </router-link>
          <div class="tooltip bot">מרכז מידע</div>
        </li> -->

        <!-- <li class="header__controls-item header__controls--disabled">
          <a href="" class="header__controls-link" tabindex="0">
            <div class="header__controls-counter" />
            <icon name="header__controls-link-4" />
          </a>
          <div class="tooltip bot">משמרות (בקרוב)</div>
        </li> -->

        <!--        <li class="header__controls-item header__controls&#45;&#45;disabled">-->
        <!--          <a href="" class="header__controls-link">-->
        <!--            <div-->
        <!--              class="header__controls-counter header__controls-counter&#45;&#45;blue"-->
        <!--            >-->
        <!--              2-->
        <!--            </div>-->
        <!--            <icon name="header__controls-link-5" />-->
        <!--          </a>-->
        <!--          <div class="tooltip bot">ישיבות (בקרוב)</div>-->
        <!--        </li>-->
        <!-- <li class="header__controls-item" v-if="!isStudent">
          <router-link
            class="header__controls-link"
            active-class="active"
            to="/chat"
            tabindex="0"
          >
            <div
              v-if="user.unreadMessages && user.unreadMessages > 0"
              class="header__controls-counter header__controls-counter--red"
            >
              {{ user.unreadMessages }}
            </div>
            <icon name="header__controls-link-10" />
          </router-link>
          <div class="tooltip bot">הודעות</div>
        </li> -->
      </ul>
      <button
        class="btn btn--border-grey st-qr-fixed qr-code"
        @click="showQRPopup = true"
        tabindex="0"
      >
        <icon name="header__sb-btn-icon-2" width="32" height="32" />
        <span>תעודה שלי</span>
      </button>
      <!-- Mobile-only back button next to the QR button. The desktop has its
           own back button further down (.header__back-btn). -->
      <button
        type="button"
        class="header__mob-back"
        aria-label="חזרה"
        @click="goBackMobile"
      >
        <icon name="header__controls-link-7" />
      </button>
      <a @click="$router.go(-1)" class="header__back-btn d-none d-lg-flex">
        <icon name="header__controls-link-7" />
        <div class="tooltip bot">חזור</div>
      </a>
      <!--      <ul class="header__nav d-none d-lg-flex">-->
      <!--        <li class="header__nav-item">-->
      <!--          <router-link to="/" class="header__nav-link">-->
      <!--            <icon name="header__controls-link-8" />-->
      <!--          </router-link>-->
      <!--          <div class="tooltip bot">מסך ראשי (בקרוב)</div>-->
      <!--        </li>-->
      <!--        <template v-if="selectedCampus">-->
      <!--          <template v-for="(menu_item, index) in menu_items">-->
      <!--            <li-->
      <!--              v-if="typeof menu_item.show == 'boolean' ? menu_item.show : true"-->
      <!--              :key="index"-->
      <!--              :class="-->
      <!--                'header__nav-item ' +-->
      <!--                (part == menu_item.active ? ' active ' : '')-->
      <!--              "-->
      <!--            >-->
      <!--              <router-link-->
      <!--                :to="{ name: menu_item.route_name }"-->
      <!--                :class="-->
      <!--                  'header__nav-link ' +-->
      <!--                  (menu_item.route_name == '' ? ' no-active ' : '')-->
      <!--                "-->
      <!--              >-->
      <!--                {{ menu_item.name }}-->
      <!--              </router-link>-->
      <!--            </li>-->
      <!--          </template>-->
      <!--        </template>-->
      <!--      </ul>-->

      <div
        class="school-switcher mr-auto"
        :class="{
          active: showCampusSelect
        }"
      >
        <InfoArticlesTooltip title="מאמרים" :items="articleItems" />
        <router-link
          v-if="selectedCampus"
          :to="{ name: 'HomePage' }"
          href=""
          class="school-switcher__current"
        >
          <img v-if="selectedCampus.logo" :src="selectedCampus.logo" alt="" />
          <span v-else>{{ selectedCampus.text }}</span>
        </router-link>

        <div
          v-if="campuses.length > 1"
          class="school-switcher__arr"
          :style="{
            pointerEvents: showCampusSelect ? 'none' : 'auto'
          }"
          @click="$hold(() => (showCampusSelect = true))"
        >
          <icon name="duration-minus-1" width="16" height="16" />
        </div>
        <ul
          v-click-outside="() => (showCampusSelect = false)"
          class="school-switcher__list"
        >
          <li
            v-for="campus of campuses"
            :key="campus.id"
            class="school-switcher__list-item"
            :class="{
              active: selectedCampus ? selectedCampus.id === campus.id : false
            }"
            @click="selectCampus(campus)"
          >
            <div class="school-switcher__list-item-logo">
              <img v-if="campus.logo" :src="campus.logo" alt="" />
              <img v-else src="/images/sm-logo.svg" alt="" />
            </div>
            <div class="school-switcher__list-item-info">
              <div class="school-switcher__list-item-title">
                {{ campus.text }}
              </div>
              <div class="school-switcher__list-item-text">פנימייה</div>
            </div>
          </li>
        </ul>
      </div>
    </header>
    <div class="menu" :class="{ active: showMenu }">
      <div class="menu__header">
        <a href="" class="menu__logo">
          <img src="/images/sm-logo-white.svg" alt="" />
        </a>
        <div class="menu__toggle-btn" @click="changeShowMenu(!showMenu)">
          <icon name="menu-new-icon" />
        </div>
      </div>
      <NewMenu :user="user" @logout="logout" />
    </div>
    <q-r-show-popup :is-show="showQRPopup" @close="showQRPopup = false" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { createPopper } from '@popperjs/core';
import QRShowPopup from '@/Pages/Security/Blocks/QRShowPopup';
import NewMenu from '@/Components/Layout/NewMenu';
import InfoArticlesTooltip from '@/Components/InfoArticlesTooltip.vue';
import NotificationBell from '@/Components/Layout/NotificationBell';

export default {
  name: 'TheHeader',
  components: { QRShowPopup, NewMenu, InfoArticlesTooltip, NotificationBell },
  props: {
    showLogoMenu: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showQRPopup: false,
      showCampusSelect: false,
      popper: undefined,
      articleItems: [
        {
          title: 'התקנת אפליקציה במחשב',
          link: 'https://help.smart-campus.co.il/he/category/hgdrvt-1soaybc/'
        },
        {
          title: 'התקנה באייפון (IOS)',
          link: 'https://help.smart-campus.co.il/he/category/hgdrvt-1soaybc/'
        },
        {
          title: 'התקנה באנדרואיד (Android)',
          link: 'https://help.smart-campus.co.il/he/category/hgdrvt-1soaybc/'
        },
        {
          title: 'כניסה ראשונה למערכת',
          link: 'https://help.smart-campus.co.il/he/category/hgdrvt-1soaybc/'
        },
        {
          title: 'עבור לכל המדריכים',
          link: 'https://help.smart-campus.co.il/he/category/hgdrvt-1soaybc/'
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    isStudent() {
      return this.$store.getters['auth/user'].entity_id === 2;
    },
    ...mapState({
      campuses: s => s.settings.campuses,
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({ user: 'auth/user', settings: 'settings/getSettings' }),
    part() {
      return this.$route.meta.part ? this.$route.meta.part : false;
    },
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    isDirector() {
      const user = this.$store.state.auth.user;

      if (user) {
        return [0, 1].includes(user.entity_id);
      }

      return false;
    },
    newMenu() {
      return [
        [
          {
            name: 'עובדים',
            img: 'menu-new-icon-3',
            url: '/workers-list',
            show: this.$perm('worker_list.show', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'תלמידים',
            img: 'menu-new-icon-2',
            url: '/student-list',
            show: this.$perm('student.list', this.selectedCampus?.id)
          },
          {
            name: 'נוכחות',
            img: 'menu-new-icon-10',
            url: '/reports',
            show:
              this.$perm('report.list', this.selectedCampus?.id) ||
              this.$perm('report.show', this.selectedCampus?.id)
          },
          {
            name: 'אישורים',
            img: 'menu-new-icon-11',
            url: '/students-security',
            show: this.$perm('student.view_parents', this.selectedCampus?.id)
          },
          {
            name: 'אירועים',
            img: 'menu-new-icon-12',
            url: '/incident-blanks',
            show: this.$perm(
              'student.view_behavior_incidents',
              this.selectedCampus?.id
            )
          }
        ],
        [
          {
            name: 'למידה',
            img: 'centers-default',
            url: '/study-center-v2/:slug/day',
            show: this.$perm('study_center.can_show', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'אחזקה',
            img: 'menu-new-icon-9',
            url: '/service-orders',
            show: this.$perm('service_orders.create', this.selectedCampus?.id)
          },
          {
            name: 'ביטחון',
            img: 'menu-new-icon-5',
            url: '/security/entry',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          },
          {
            name: 'מבקרים',
            img: 'menu-new-icon-4',
            url: '/own-permission',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'הגדרות',
            img: 'menu-new-icon-8',
            url: '/settings',
            show: this.$perm('settings.view', this.selectedCampus.id)
          }
        ]
      ];
    }
  },
  watch: {
    showCampusSelect(v) {
      if (this.popper) {
        this.popper.destroy();
      }
      this.$nextTick(() => {
        const button = this.$refs['sub-dropdown-btn'];
        const element = this.$refs['sub-dropdown'];
        if (button && element) {
          this.popper = createPopper(button, element, {
            placement: 'bottom',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [-18, 0]
                }
              }
            ]
          });
        }
      });
    },
    $route(v) {
      if (+v.query['open-menu'] === 1) {
        this.hideSidebar(true);
      }
    }
  },
  mounted() {
    this.CHANGE_SELECTED_CAMPUS_LIST();
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
      setSidebarStatus: 'front/setSidebarStatus',
      CHANGE_SELECTED_CAMPUS_LIST: 'settings/CHANGE_SELECTED_CAMPUS_LIST'
    }),
    changeShowMenu(menu) {
      this.$emit('showMenu', menu);
    },
    goBackMobile() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    showUserAvatar(state) {
      if (state) {
        this.$emit('isCloseUserAvatar', false);
      }
      if (this.showLogoMenu === false) {
        this.$emit('isCloseUserAvatar', true);
      }
      if (this.showLogoMenu === true) {
        this.$emit('isCloseUserAvatar', false);
      }
    },
    closeUserAvatarHeader() {
      this.$emit('isCloseUserAvatar', false);
    },
    async logout() {
      await this.signOut();
    },
    hideSidebar($event, value = true) {
      // On mobile the hamburger now navigates to a dedicated menu page so
      // users get a real route they can swipe-back from.
      if (this.isMobile && value === true) {
        if (this.$route.name !== 'MobileMenu') {
          this.$router.push({ name: 'MobileMenu' });
        }
        return;
      }
      this.setSidebarStatus(value);
      localStorage.setItem('showMenu', value);
    },
    showMenuHeader() {
      this.changeShowMenu(true);
      this.hideSidebar(null, false);
    },
    selectCampus(campus) {
      this.$store.commit('settings/SET_SELECTED_CAMPUS', campus);
      this.showCampusSelect = false;
    }
  }
};
</script>
<style scoped lang="scss">
.header__controls {
  background: transparent !important;
}
.audit-tooltip {
  width: 50px;
  white-space: break-spaces;
}
.knowled {
  svg {
    stroke: #5a6f95 !important;
  }
}
@media (min-width: 1024px) {
  .qr-code {
    display: none;
  }
}
</style>
